import { SparkleIcon } from '@orn/shared-web/icons';

interface ISuggestionChipProps {
  /** The action, as the assistant worded it. Also what gets sent when clicked. */
  text: string;
  /**
   * Send the suggestion as an ordinary user turn. Omitted — in Storybook, or
   * before the pane wires it — the pill renders inert rather than disabled: a
   * greyed-out suggestion reads as "unavailable" when the truth is that
   * nothing is listening.
   */
  onSelect?: (text: string) => void;
}

/**
 * A suggested next action, offered at the end of an expanded alert's reply.
 * Clicking sends the suggestion's own words back as if the user had typed
 * them — which is why the label is the payload rather than a key: the
 * assistant sees exactly what the user saw itself agree to.
 *
 * Renders as a block so a run of them stacks, matching the design; the
 * directive asks for one per line for the same reason.
 */
const SuggestionChip = ({ text, onSelect }: ISuggestionChipProps) => (
  <button
    type="button"
    onClick={onSelect === undefined ? undefined : () => onSelect(text)}
    className="bg-utility-mist-100 border-utility-mist-200 text-primary hover:bg-utility-mist-200 rounded-4xl text-md my-1 flex w-fit items-center gap-2 border px-5 py-3 text-left font-medium transition-colors"
  >
    <SparkleIcon className="text-utility-brand-825 size-3 shrink-0" />
    {text}
  </button>
);

export default SuggestionChip;
